<template>
  <v-text-field
    outlined
    dense
    label="CPF"
    :hide-details="!error"
    :error="error"
    :error-messages="errorMessages"
    :disabled="disabled"
    v-mask="'###.###.###-##'"
    v-model="cpf"
    @input="evOnCPFInput"
    @change="evOnCPFChange"
  >
  </v-text-field>
</template>

<script>
import { numbersOnly } from "../../lib/format";

export default {
  name: "VTextFieldCPF",

  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      loading: false,
      error: false,
      cpf: "",
    };
  },

  watch: {
    value() {
      if (String(this.value).match(/^\d{11}$/))
        this.cpf = this.value.replace(
          /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
          "$1.$2.$3-$4"
        );
      else this.cpf = this.value;
    },
  },

  computed: {
    errorMessages() {
      return this.error ? ["CPF Inválido"] : [];
    },
  },

  methods: {
    async evOnCPFInput(value) {
      this.$emit("input", value);
    },

    async evOnCPFChange(value) {
      this.$emit("change", value);
      this.validate();
    },

    validate() {
      let valid = false;

      try {
        let cpf = numbersOnly(this.cpf).split("");

        if (cpf.length !== 11) return;

        //000.000.000-00 ... 999.999.999-99
        if ([...new Set(cpf)].length == 1) return;

        let a2 = cpf.pop();
        let a1 = cpf.pop();

        cpf = cpf.reverse();

        let v1 = 0;
        let v2 = 0;

        for (let i = 0; i < cpf.length; i++) {
          v1 = v1 + parseInt(cpf[i]) * (9 - (i % 10));
          v2 = v2 + parseInt(cpf[i]) * (9 - ((i + 1) % 10));
        }

        v1 = (v1 % 11) % 10;
        v2 = v2 + v1 * 9;
        v2 = (v2 % 11) % 10;

        if (a1 != v1 || a2 != v2) return;

        valid = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.error = !valid;
      }
    },
  },
};
</script>

<style>
</style>
